// src/auth.js
// Phase 1 — Refresh token JWT
// - Login stocke access_token + refresh_token
// - refreshTokens() échange le refresh contre de nouveaux tokens
// - logout() appelle POST /auth/logout pour révoquer côté serveur
import API from "./api";

const KEYS = {
  access:  "access_token",
  refresh: "refresh_token",
  type:    "token_type",
  admin:   "is_admin",
  user:    "user_info",
};

// ── Helpers stockage ──────────────────────────────────────────────
function saveTokens({ access_token, refresh_token, token_type, is_admin }) {
  localStorage.setItem(KEYS.access,  access_token);
  localStorage.setItem(KEYS.refresh, refresh_token);
  localStorage.setItem(KEYS.type,    token_type || "bearer");
  localStorage.setItem(KEYS.admin,   String(Boolean(is_admin)));
}

function clearTokens() {
  Object.values(KEYS).forEach(k => localStorage.removeItem(k));
}

// ── Login ─────────────────────────────────────────────────────────
export async function login(username, password) {
  const response = await API.post("/auth/login", { username, password });
  saveTokens(response.data);
  return response.data;
}

// ── Refresh ───────────────────────────────────────────────────────
export async function refreshTokens() {
  const refresh_token = localStorage.getItem(KEYS.refresh);
  if (!refresh_token) throw new Error("Pas de refresh token");

  try {
    const response = await API.post("/auth/refresh", { refresh_token });
    saveTokens(response.data);
    return response.data.access_token;
  } catch (err) {
    // Refresh invalide/expiré → déconnexion forcée
    clearTokens();
    window.dispatchEvent(new Event("auth-changed"));
    window.location.href = "/login?expired=1";
    throw err;
  }
}

// ── Logout ────────────────────────────────────────────────────────
export async function logout() {
  try {
    // Révocation côté serveur (best-effort)
    await API.post("/auth/logout");
  } catch {
    // Ignorer si déjà expiré
  } finally {
    clearTokens();
    window.dispatchEvent(new Event("auth-changed"));
  }
}

// Alias pour compatibilité ancienne API
export { clearTokens as clearToken };

// ── Getters ───────────────────────────────────────────────────────
export function getToken()        { return localStorage.getItem(KEYS.access); }
export function getRefreshToken() { return localStorage.getItem(KEYS.refresh); }
export function isLoggedIn()      { return !!getToken(); }
export function isAuthenticated() { return isLoggedIn(); }
export function isAdmin()         { return localStorage.getItem(KEYS.admin) === "true"; }

// ── Bootstrap user info ───────────────────────────────────────────
export async function bootstrapUserInfo() {
  try {
    const response = await API.get("/users/me");
    localStorage.setItem(KEYS.user, JSON.stringify(response.data));
    return response.data;
  } catch (err) {
    console.error("bootstrapUserInfo failed:", err);
    throw err;
  }
}
